import React from 'react'

type Props = {
  children: React.ReactNode
}

type State = {
  hasError: boolean
  error?: string
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error: error?.stack || error?.message || String(error) }
  }

  componentDidCatch(error: Error) {
    console.error('Odin SOC UI crash:', error)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', background: '#08111f', color: '#e8f0fb', padding: 24, fontFamily: 'Inter, system-ui, sans-serif' }}>
          <h1 style={{ marginTop: 0 }}>Odin SOC hit a UI error</h1>
          <p style={{ color: '#93a4bd' }}>The app did not go blank silently. The crash was caught so we can fix it fast.</p>
          <pre style={{ whiteSpace: 'pre-wrap', background: '#0f1b2d', padding: 16, borderRadius: 12, border: '1px solid rgba(135, 169, 214, 0.14)' }}>
            {this.state.error}
          </pre>
        </div>
      )
    }
    return this.props.children
  }
}
